module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"description":"Visualizza tutte le foto del progetto Time To Change."},"en":{"description":"See all the photos of the Time To Change project."}}')
  delete Component.options._Ctor
}
